import { CREATE_MESSAGE, CREATE_GENERIC_ERROR_ALERT, CLEAR_ALERT } from "./types";
import axios from "axios";


// CREATE GENERIC WARNING MESSAGE AND ALERT
export const clearMessage = (id) => {
	return {
		type: CLEAR_ALERT,
		payload: id
	};
};

// CREATE MESSAGE AND ALERT
export const createMessage = (msg) => {
    const id = Date.now();
	return {
		type: CREATE_MESSAGE,
		payload: {...msg, id}
	};
};

// CREATE GENERIC WARNING MESSAGE AND ALERT
export const createGenericErrorAlert = (details) => {
    const id = Date.now();
	return {
		type: CREATE_GENERIC_ERROR_ALERT,
		payload: {serverError: "Sorry! Something went wrong. Please try again.", ...details, id}
	};
};

// CLEAR REGISTRATION
export const alertPermissionsRequired = () => {
    const id = Date.now();
	return {
		type: CREATE_MESSAGE,
		payload: {info: `Permissions required. Contact your company admin`, id}
	};
}
